import { Reducer } from 'redux';

import { IUserState } from 'types/user.types';
import * as constants from 'redux/constants/user.constants';

export const defaultState: IUserState = {
  data: null,
  loading: false,
};

const userReducer: Reducer = (state = defaultState, action) => {
  const { data, error, type } = action;
  switch (type) {
    case constants.USER_ON_LOGIN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.USER_ON_INITIALIZE_SUCCEEDED:
    case constants.USER_ON_LOGIN_SUCCEEDED:
      return {
        ...state,
        data: data.user,
        loading: false,
      };
    case constants.USER_ON_LOGOUT_SUCCEEDED:
    case constants.USER_ON_INITIALIZE_FAILED:
    case constants.USER_ON_LOGIN_FAILED:
      return defaultState;
    case constants.USER_ON_LOGOUT_FAILED:
    default:
      return error?.response?.status === 401 ? defaultState : state;
  }
};

export default userReducer;
